import React from 'react'
import { useLocation } from 'react-router-dom'
import { SearchFilter } from 'components'
import { useSegments } from '../SegmentsProvider'

const SegmentsSearchFilter = (): React.ReactElement => {
  const { filters, redirect } = useSegments()
  const { pathname } = useLocation()

  return <SearchFilter pathname={pathname} redirect={redirect} filters={filters} />
}

export default SegmentsSearchFilter
